module.exports = __webpack_public_path__ + "static/img/flat.4a223dea.png";